import 'raf/polyfill';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'react-day-picker/lib/style.css';
import './styles/main-overide.css';
import './styles/visitation-form.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import App from './App';
console.log('VADOC - Visitation Application - V.2.0.9');
ReactDOM.render(
	<Router>
		<App />	
	</Router>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js